<ng-container>
  @if (!(isLoading$ | async)) {
    <div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Domain:</span>
          <select [(ngModel)]="options.domain" (ngModelChange)="fetchDomainValues()">
            @for (domain of domains | async; track domain) {
              <option [ngValue]="domain.id">{{domain.description}}</option>
            }
          </select>
        </label>
      </div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Id Property:</span>
          <select [(ngModel)]="options.idProperty" [disabled]="!options.domain && !(domainProperties | async)">
            @for (property of domainProperties | async; track property) {
              <option [ngValue]="property">{{property}}</option>
            }
          </select>
        </label>
      </div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Display Property:</span>
          <select [(ngModel)]="options.displayProperty" [disabled]="!options.domain && !(domainProperties | async)">
            @for (property of domainProperties | async; track property) {
              <option [ngValue]="property">{{property}}</option>
            }
          </select>
        </label>
      </div>
    </div>
  } @else {
    Loading data...
  }
</ng-container>